//--------------collection page
	$(document).ready(function() {
		$(".view_option span").click(function () {
			$(".view_option span").removeClass("active");
			$(this).addClass("active");   
		});
		$(".list-view").click(function () {
			$("#product-grid").addClass("list_view");   
		});
		$(".grid-view").click(function () {
			$("#product-grid").removeClass("list_view");  
		});	
       // breadcrumbs
    	var totalCount = $("nav.breadcrumbs li").length;
        var coll_title = $('.collection__title.new').text();
    	var breadcrumb = '<ul><li><a href="/" title="Home">Home</a></li><li class="level" style="display: block;"><a href="/collections">All</a></li><li class="level2" style="display: block;" aria-current="page"><a href="#">' + coll_title + '</a></li></ul>'
    	if (totalCount == 1) {
    		 $("nav.breadcrumbs").html(breadcrumb);
    	}   
// expand list sidebar
        $('.category_container>span').click( function(){
          $(this).toggleClass('open');
      	$(".category_container ul.side-menu").slideToggle( "slow");
        })             
	});	

$("li.level2:first,li.level3:first,li.level4:first").css("display", "block");


//sidebar
$(document).ready(function() {
  //toggle the component with class accordion_body
  $(".accordion_head").click(function() {
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
});